const SEGMENT = {
  PAGES: {
    HOME: 'Home Estimator'
  },
  TRACKS: {
    ESTIMATES_REQUESTED: 'Estimates Requested'
  }
};

export default SEGMENT;